module.exports = __webpack_public_path__ + "static/media/user.78242f82.jpg";